<template>
  <div id="info-view">
    <mt-popup v-model="show" :closeOnClickModal="0" class="info-popup">
      <div class="header" v-show="type==='1'">服务价格</div>
      <div class="header" v-show="type==='2'">招募要求</div>
      <div class="header" v-show="type==='3'">招募资格</div>
      <div class="header" v-show="type==='4'">操作指南</div>
      <div class="content content1" v-show="type==='1'">
        <div class="title">1. 安保服务价格</div>
        <div><span style="color: #333333;line-height: 20px;">
            <span style="color: #c41335;">*</span>&nbsp;一线和二线城市的安保服务价格：
            <br />一天<span style="color: #c41335;">384</span>元/位（日间服务8小时）</span>
          <br />日间服务价：<span style="color: #c41335;">384元/位</span>（08:00-16:00）
          <br />夜间服务价：<span style="color: #c41335;">480元/位</span>（16:00-00:00）
          <br />深夜服务价：<span style="color: #c41335;">576元/位</span>（00:00-08:00）</div>
        <div style="margin-top: 10px;">
          <span style="color: #333333;line-height: 20px;">
            <span style="color: #c41335;">*</span>&nbsp;三线和四线城市的安保服务价格：
            <br />一天<span style="color: #c41335;">288</span>元/位（日间服务8小时）</span>
          <br />日间服务价：<span style="color: #c41335;">288元/位</span>（08:00-16:00）
          <br />夜间服务价：<span style="color: #c41335;">360元/位</span>（16:00-00:00）
          <br />深夜服务价：<span style="color: #c41335;">432元/位</span>（00:00-08:00）
        </div>
        <div style="color: #333333;margin-top: 10px;">
          <span style="color: #c41335;">*</span>&nbsp;根据国家重点节假日，安保服务价格也适当调整</div>
        <div class="title">2. 消防车租赁价格</div>
        <div style="color: #333333;">消防车租赁价：<span style="color: #c41335;">一天1200元/辆</span></div>
        <div class="title">3. 注意事项</div>
        <div style="color: #333333;">
          <span style="color: #c41335;">*</span>&nbsp;江浙沪最少提前3天预订，省外最少提前7天预订
          <br /><span style="color: #c41335;">*</span>&nbsp;安保需求严格的可以采取三班连班制
        </div>
        <div class="close" v-on:click='cancelClick'></div>
      </div>
      <div class="content content2" v-show="type==='2'">
        <div class="info">
          1. 熟悉国家消防法律、法规、规章及相关规定，具有较丰富的消防安全技术工作经验
          <br />2. 了解国际消防相关标准和技术规范，及时掌握消防技术前沿发展动态，能够独立解决重大、复杂、疑难的消防安全技术问题
          <br />3. 熟练运用消防相关技术标准、规范和手段，圆满完成执业范围内各项工作，所维护的消防设施完好有效
          <br />4. 能够进行区域消防安全评估、建筑消防安全评估、火灾高危单位进行安全评估，大型活动消防安全评估，建筑防火性能化设计评估
          <br />5. 能进行消防法规、设计标准、火灾隐患整理的技术咨询，制定消防训练计划，并推动训练实施
          <br />6 .熟悉消防设备原理特性，有一定的供方资源
        </div>
        <div class="close" v-on:click='cancelClick'></div>
      </div>
      <div class="content content3" v-show="type==='3'">
        <div class="info">
          1. 全国范围招募
          <br />2 . 具备有注册消防工程师职称，有高工证者优先
          <br />3 . 能够熟练掌握运用《建筑防火设计规范》等消防规范、标准开展消防评估，有安全评估或消防评估工作经验
          <br />4 . 专家组分为区县级、省级、国家级三个等级
          <br />5 . 专家组成员按照国家认同的技术资质进行层级定位
        </div>
        <div class="close" v-on:click='cancelClick'></div>
      </div>
      <div class="content content4" v-show="type==='4'">
        <div class="info">
          由于safari浏览器的最新安全策略，导致合同无法正常预览。请按以下步骤设置safari浏览器。
          <br>1. 打开设置，进入safari浏览器。<img class="cssImg" :src="pathImg" />
          <br>2. 关闭“阻止跨网站跟踪”选项。
          <br>3. 回到浏览器，刷新页面。
        </div>
        <div class="close" v-on:click='cancelClick'></div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
export default {
  props: {
    show: false,
    type: 0 // 1 应急保障服务价格 2,3 专家招募(招募资格、招募要求) 4
  },
  data () {
    return {
      pathImg: require('../assets/zhinan3.png')
    }
  },
  methods: {
    cancelClick: function (index) {
      // 取消
      this.$emit('infoViewClick', index)
    }
  },
  mounted () {}
}
</script>

<style scoped>
.info-popup {
  position: center;
  width: 90%;
  /*height: 200px;*/
  min-height: 100px;
  border-radius: 3px;
}
.info-popup .header {
  width: 100%;
  padding-left: 20px;
  height: 45px;
  line-height: 45px;
  background-color: #c41335;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
}
.info-popup .content {
  width: 100%;
  padding: 15px 15px 20px 15px;
  color: #323232;
  font-size: 12px;
  line-height: 20px;
  color: #808080;
}
.info-popup .content1 .title {
  font-size: 14px;
  font-weight: bold;
  color: #000000;
  line-height: 25px;
}
.info-popup .content .close {
  position: fixed;
  position: -ms-device-fixed;
  width: 36px;
  height: 36px;
  background-image: url(../assets/close.png);
  background-size: cover;
  background-position: center center;
  margin-bottom: 0px;
  left: 50%;
  top: calc(100% + 35px);
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
}
.content2 .info,
.content3 .info {
  font-size: 14px;
  color: #000000;
  line-height: 25px;
  /*background-color: yellow;*/
}
.content4 .info {
  position: relative;
  font-size: 16px;
  color: #000000;
  line-height: 35px;
}
/* img[src=""],img:not([src]){
  opacity: 0;
} */

.cssImg {
  width: 100%;
  height: 106px;
}
</style>



// WEBPACK FOOTER //
// src/components/info-view.vue